import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, filter } from 'rxjs';

import { ChatUnreadCountUpdatedPayload } from '../models/chat';
import { ChatSocketService } from './chat-socket.service';
import { ClienteChatService } from './cliente-chat.service';

@Injectable({
  providedIn: 'root'
})
export class ChatUnreadSessionService {
  private readonly unreadCountSubject = new BehaviorSubject<number>(0);
  private subscriptions = new Subscription();
  private active = false;

  readonly unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(
    private chatService: ClienteChatService,
    private chatSocket: ChatSocketService
  ) {}

  public start(): void {
    if (this.active) {
      return;
    }

    this.active = true;
    this.subscriptions.add(
      this.chatSocket.eventsOfType<ChatUnreadCountUpdatedPayload>('unread_count.updated')
        .subscribe((event) => this.unreadCountSubject.next(event.payload.unread_count_client))
    );
    this.subscriptions.add(
      this.chatSocket.connectionState$
        .pipe(filter((state) => state === 'open'))
        .subscribe(() => this.refreshUnreadCount())
    );

    this.refreshUnreadCount();
    this.chatSocket.connect();
  }

  public stop(): void {
    if (!this.active) {
      return;
    }

    this.active = false;
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();
    this.unreadCountSubject.next(0);
    this.chatSocket.disconnect();
  }

  private refreshUnreadCount(): void {
    if (!this.active) {
      return;
    }

    this.chatService.obtenerNoLeidos().subscribe({
      next: (response) => {
        if (this.active) {
          this.unreadCountSubject.next(response.unread_count_client);
        }
      },
      error: () => undefined
    });
  }
}
